import React from 'react';
import './Skeleton.css';

/**
 * Baustein 8a — Skeleton.
 * Graue Placeholder-Boxen in Form des kommenden Inhalts. Dezenter Pulse.
 *
 * Props:
 *   width   — CSS width (default '100%')
 *   height  — CSS height (default '1em')
 *   radius  — Radius-Token-Name (default 'md')
 *   label   — optional: Text für Screenreader, z.B. „Playtests werden geladen". Nötig, wo der
 *             Platzhalter allein steht und die Umgebung nicht sagt, was dort lädt; die graue
 *             Fläche selbst bleibt für Screenreader unsichtbar und wäre sonst gar nichts.
 */
export default function Skeleton({ width = '100%', height = '1em', radius = 'md', label }) {
  return (
    <>
      <span
        className="skeleton"
        style={{ width, height, borderRadius: `var(--radius-${radius})` }}
        aria-hidden
      />
      {label && <span className="skeleton__label">{label}</span>}
    </>
  );
}
